import * as track from 'lib/gaTracking/bookingListPageEvents';
import { BookingListResponseData } from '../../types';
import { updateQuery } from '../updateQuery/updateQuery';

interface CreateFetchMoreHandlerArguments {
  filter?: string;
  data: BookingListResponseData;
  fetchMore: Function;
}

export const createFetchMoreHandler =
  ({ data, fetchMore, filter }: CreateFetchMoreHandlerArguments) =>
  () => {
    if (!data || !fetchMore) return null;

    const offset = data.bookingList.bookings.length;

    track.loadMoreButton(offset, filter);

    fetchMore({
      variables: { offset },
      updateQuery,
    });
  };
